import { TEXT_200 } from 'style/constants';
import styled from 'styled-components';

export const MessageContent = styled.span`
  word-wrap: break-word;
  color: ${TEXT_200};
`;
